import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightningBolt: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="lightning-bolt, speed, thunder, flash, high woltage"><path d="M6.25 14L13.5 4.5L13 10H17.75L10.5 19.5L11 14H6.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLightningBolt;
